import { typeRoutes, fields, connections, dataShow, paginationList, sidebarExtra } from '../structure'
import { mapState } from 'vuex'



const listMixins = {
	data() {
    return {
      datos: [],
      titleCard: null,
      acciones: [
        {
          type: 'action',
          name: 'Borrar',
          color: 'warning',
          action: this.deleteItem,
          icon: 'delete_forever'
        },
        {
          type: 'link',
          name: 'Editar',
          color: 'success',
          to: typeRoutes.editRoute,
          icon: 'create'
        }
      ]
    }
  },
	computed: {
    ...mapState('listItems',['items', 'params', 'orderColumns', 'searching']),
	},
	methods: {
		addResults() {
      this.$store.dispatch('listItems/addResults', {functionToAdd: this.getResults})
    },
		getResults(refresh) {
			this.$store.commit('setLoading', true)
			if (refresh) {
        this.$store.dispatch('listItems/resetLimits', {limit: paginationList.limit, results: paginationList.results })
      }
			
			
			
      var where = []
			
			// console.log(this.orderColumns)
			
			// if( this.orderColumns.column.id == "id" ) this.orderColumns.column.id = "tipo_suscripcion" 
			var orderBy = []
				
			if( this.orderColumns.column.id != "id" ) 
      		orderBy = [[this.orderColumns.column.id, this.orderColumns.column.order]]

      if (this.searching.field && (this.searching.text != '' && this.searching.text != null)) {
        where = [[this.searching.field, '>=', this.searching.text], [this.searching.field, '<=', this.searching.text + '~']]
        orderBy = [[this.searching.field, 'asc']]
      } else {
        this.$store.commit('listItems/setSearching', {local:false})
      }

      var paramsTo = {
				url: connections.typeUrl,
				filter: {
          ...{where},
					...{orderBy},
					startAfter: this.params.lastElement,
					limit: this.searching.field && (this.searching.text != '' && this.searching.text != null) ? false : this.params.limit
        }
      }
			
			if (!this.searching.local) {
        this.$connector.get(connections.constType, paramsTo)
        .then(data => {
					
					data.docs.length == this.params.limit ? this.$store.commit('listItems/setParamsLastElement', data.docs[data.docs.length-1]) : this.$store.commit('listItems/setParamsLastElement')
          
					var list = []
          data.forEach(element => {
					
						// 
						// var req = new XMLHttpRequest();
						// req.onreadystatechange = function() {
						//     if (req.readyState === 4) {
						//         var response = req.responseText;
						//         var json = JSON.parse(response);
						// 
						//         list.push({id: element.id, auth: json,  ...element.data()})
						//     }
						// };
						// 
						// req.open('GET', 'https://admin.tongshuapp.com/firebase/user.php?id=' + element.id);
						// req.send(null);
						
						list.push({id: element.id, ...element.data()})
          })
          if (this.params.results == this.params.limit || refresh == true) {
            this.$store.commit('listItems/setItems', {refresh:true, data: list})
          } else {
            this.$store.commit('listItems/setItems', {data: list})
          }
          this.$store.commit('setLoading', false)
          if (where.length != 0)
            this.$store.commit('listItems/setSearching', {local:true}) 
        })
        .catch(error => {
          console.log(error)
          this.$store.commit('setLoading', false)
        })
      } else {
        this.$store.commit('setLoading', false)
      }

		},
		deleteItem(id, nombre) {
      var parentThis = this
      this.$store.commit('setDialog', {
        dialogOpen: true,
        title: 'Estas seguro que quieres borrar el usuario:  ' + nombre,
        onOk: () => {
          var body = {token: 'tongshu', uid: id}
          // this.$store.dispatch('login/delete', {uid: id})
          this.$connector.delete(connections.constType, {url: connections.typeUrl, id: id})
          .then(() => {
            this.$store.commit('setLoading', true)
            this.$store.commit('cancelDialog')
          })

          parentThis.$http.post('http://tongshu1.ztudio.es/deleteUser', body )
          .then(response => {
            if (response.status == 200) {
              this.$store.commit('setLoading', false)
              this.$store.commit('setSnackbar', {texto: 'Se ha borrado con éxito el ID '+ nombre, active: true})
              this.getResults(true)
            }
          })
          .catch(error => {
            console.log(error)
          })
        },
        onCancel: () => { this.$store.commit('cancelDialog') }
      })
    },
    changeView() {
      this.$store.commit('listItems/toggleViewList')
    }
	},
	created() {
    var columns = []
    var columnSelected = null
    var titled = null
		
		
		
    this.datos = dataShow.map(d => {
      if (d.selected == true) columnSelected = d
      columns.push(d)
      return d
    })

    fields.map(d => {
      if (d.titled == true) titled = d
    })

    this.titleCard = titled

    var dataColumns = {
      data: {
        items: columns,
        column: columnSelected,
        refreshFunction: this.getResults
      }
    }
		
		

    // Reset depends
    this.$store.dispatch('listItems/resetLimits', {limit: paginationList.limit, results: paginationList.results})
    this.$store.commit('listItems/resetParams', {limit: paginationList.limit, results: paginationList.results})
    this.$store.commit('listItems/cleanSearching')

    // Setear datos
    this.$store.commit('listItems/setOrderColumns', dataColumns)
    this.getResults()

    // this.$store.commit('listItems/setSearching', {field: columnSelected.id, searchFunction: this.getResults})

    if (this.$route.meta.extraSidebar === true){
      this.$store.commit('setExtraSidebar', {compSidebar: sidebarExtra.list})
    }

    var listActions = [
      {icon: 'add', action: () => { this.$router.push(typeRoutes.newRoute)}, name: "Añadir código nuevo", class: "green"},
			{icon: 'view_list', action: this.changeView, name: "Cambiar de vista"}      
    ]
    
    var toolbarOptions = {
      title: this.titlePage,
      actions: listActions
    }

    this.$store.commit('toolbarOptions', toolbarOptions)

    // Scroll infinito y en la funcion "beforeDestroy"
    window.addEventListener('scroll', this.addResults);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.addResults);
  }
}

export { listMixins }
